import CitySEOHead from "@/components/feature/CitySEOHead";
import MetairieHeroSection from "./components/HeroSection";
import MetairieStickyNav from "./components/StickyNav";
import MetairieProcessingTimeSection from "./components/ProcessingTimeSection";
import MetairieServicesSection from "./components/ServicesSection";
import MetairieLocalAreaSection from "./components/LocalAreaSection";
import MetairieTestimonialsSection from "./components/TestimonialsSection";
import MetairieAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MetairieComparisonSection from "./components/ComparisonSection";
import MetairieMistakesSection from "./components/MistakesSection";
import MetairieHowItWorksSection from "./components/HowItWorksSection";
import MetairieFAQSection, { faqs } from "./components/FAQSection";
import MetairieHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MetairieFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import MetairieTravelTimingSection from "./components/TravelTimingSection";
import MetairieDestinationsSection from "./components/DestinationsSection";

export default function MetairiePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Metairie"
        state="Louisiana"
        stateAbbr="LA"
        route="/metairie"
        title="Emergency Passport Metairie, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Metairie, LA — as fast as 24 hours. Serving Lakeside professionals, Elmwood executives, and Jefferson Parish families. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Metairie, Louisiana"
        geoPosition="29.9841;-90.1529"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Metairie travelers with immediate departure needs — as fast as 24 hours for Jefferson Parish residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Metairie with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for Metairie and Lakeside area families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Metairie, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Jefferson Parish families." },
          { name: "Name Change", description: "Passport correction and name change service for Metairie residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for Lakeside professionals and frequent international travelers from Metairie." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <MetairieHeroSection />
      <MetairieStickyNav />
      <MetairieProcessingTimeSection />
      <MetairieLocalAreaSection />
      <MetairieServicesSection />
      <MetairieTravelTimingSection />
      <MetairieDestinationsSection />
      <MetairieTestimonialsSection />
      <MetairieAcceptanceFacilitiesSection />
      <MetairieComparisonSection />
      <MetairieMistakesSection />
      <MetairieHowItWorksSection />
      <MetairieFAQSection />
      <MetairieHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/metairie" state="LA" />
      <MetairieFinalCTA />
    </div>
  );
}